import { render, staticRenderFns } from "./ReportListsWinloseComponent-v1.vue?vue&type=template&id=71c10bb5&"
import script from "./ReportListsWinloseComponent-v1.vue?vue&type=script&lang=js&"
export * from "./ReportListsWinloseComponent-v1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports